export default __webpack_public_path__ + "static/media/Trash_Dark.c58bf757.svg";